document.addEventListener("scroll", (e) => {
    var scrollDistance = document.documentElement.scrollTop;
    var windowHeight = window.innerHeight;
    var bgChanges = document.querySelectorAll('div.quieton-scroll-color');

    bgChanges.forEach((change) => {
        let changePosition = change.offsetTop;
        let changeStartPosition = changePosition - 100;
        let changeEndPosition = changePosition + 100;
        let changeStartColor = change.getAttribute("data-startcolor");
        let changeEndColor = change.getAttribute("data-endcolor");

        if ( scrollDistance > changeStartPosition ) {
            document.body.style.backgroundColor = changeEndColor;
        } else {
            document.body.style.backgroundColor = changeStartColor;
        }
    });
});